import React from "react";
import RevenueDashboard from "./RevenueDashboard";

const Dashboard: React.FC = () => {
  return <RevenueDashboard />;
};

export default Dashboard;